module.exports = __webpack_public_path__ + "img/8_HOPE.11fb7c35.jpg";